export enum Flags {
  HOMEPAGE_FEATURE = 'asset-store-new-homepage',
  SHOW_PURCHASED_STATE = 'asset-store-show-product-purchased-state',
  NEW_LANDING_PAGES = 'as-new-landing-pages',
  NON_CURATED_PLP_WITH_ML = 'as-coveo-non-curated-plp-with-ml',
  NON_CURATED_PLP = 'as-non-curated-plp',
  OPEN_RESULTS_IN_NEW_TAB = 'as-asset-results-new-tab',
  INCREASE_DEFAULT_RESULTS_PER_PAGE = 'as-increase-default-coveo-results-per-page',
  FREE_UPM_BETA = 'as-free-upm-beta',
  PAID_UPM = 'as-paid-upm',
  UPM_REVIEWS = 'as-upm-reviews',
  VOUCHER_PAGE = 'as-voucher-page',
  AS_JV_CHINA_RESTRICTED_ACCESS = 'as-jv-china-restricted-access',
  SEARCH_SSR = 'as-search-ssr',
  TRENDING_SEARCH = 'as-trending-search',

  PRODUCT_LISTS = 'as-wishlist',
  SALE_NAV_RED = 'as-sale-nav-red',
  MULTI_CART = 'as-multi-cart',
}

export const FLAG_CONTROL = 'control';
export const FLAG_TREATMENT = 'treatment';

// keys specific for NON_CURATED_PLP_WITH_ML
export const FLAG_TREATMENT_NO_ML = 'treatment-no-ml';
export const FLAG_TREATMENT_ML = 'treatment-ml';

// keys specific for TRENDING_SEARCH
export const FLAG_TREATMENT_QS = 'treatment-qs';
export const FLAG_TREATMENT_UA = 'treatment-ua';

export const FEATURE_FLAG_ON = 'on';
export const FEATURE_FLAG_OFF = 'off';
